export default __webpack_public_path__ + "static/media/3.90c3a8b8.jpeg";